import CustomTablePagination from 'Components/CustomTablePagination'
import EnhancedTableHead, { type HeadCell } from 'Components/EnhancedTableHead/EnhancedTableHead'
import { WithLoader } from 'Components/WithLoader'
import { MultiCodeCampaignListRow } from 'Services/SalesManagement/Features/Campaign/Components/MultiCodeCampaignListRow'
import type {
  CampaignParamShape,
  MultiCodeCampaignShape
} from 'Services/SalesManagement/Features/Campaign/campaignSlice'
import { ROWS_PER_PAGE_DEFAULT } from 'Util/constants'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import type { FC } from 'react'
import { t } from 'ttag'

const MultiCodeCampaignList: FC<{
  rows: MultiCodeCampaignShape[]
  loading: string
  params: CampaignParamShape
  handleRequestSort: (event: React.MouseEvent<unknown>, property: string) => void
  handleChangePage: (event: unknown, newPage: number) => void
  count: number
}> = ({ rows, loading, params, handleRequestSort, handleChangePage, count }) => {
  const headCells: HeadCell[] = [
    {
      id: 'created',
      numeric: false,
      disablePadding: false,
      label: t`Created`,
      sortable: true
    },
    {
      id: 'name',
      numeric: false,
      disablePadding: false,
      label: t`Name`,
      sortable: false
    },
    {
      id: 'start_date',
      numeric: false,
      disablePadding: false,
      label: t`Active from`,
      sortable: true
    },
    {
      id: 'end_date',
      numeric: false,
      disablePadding: false,
      label: t`Active to`,
      sortable: true
    },
    {
      id: 'authorities',
      numeric: false,
      disablePadding: false,
      label: t`Authority`,
      sortable: false
    },
    {
      id: 'discount_code',
      numeric: false,
      disablePadding: false,
      label: t`Discount codes`,
      sortable: false
    }
  ]

  return (
    <WithLoader loading={loading === 'pending'} rows={ROWS_PER_PAGE_DEFAULT} height={33}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
            <EnhancedTableHead
              orderBy={params.ordering}
              headCells={headCells}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {rows.map((row: MultiCodeCampaignShape) => (
                <MultiCodeCampaignListRow key={row.id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <CustomTablePagination
          count={count}
          page={params.page - 1}
          onPageChange={handleChangePage}
        />
      </Paper>
    </WithLoader>
  )
}

export { MultiCodeCampaignList }
